import React from "react";
import GridLine, {BackgroundColor} from "../../../../../../../components/layouts/grid-line-layout/grid-line/grid-line";
import FontBody2 from "../../../../../../../components/fonts/font-body2/font-body2";
import {FONT_COLOR, FONT_VARIANT} from "../../../../../../../components/fonts/font-props";

const PlanPricingGridLine: React.FC<{ price: number | string }> = ({price}) => {
    return <GridLine
        backgroudColor={BackgroundColor.LIGHT}
        withBorder={false}
        withoutSidePadding={true}
        settings={
            {
                columns: [{width: 5}, {width: 2.5}, {width: 4}]
            }
        }
        columns={[
            <div>
                <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                    Plan price:
                </FontBody2>
            </div>,
            <div/>,
            <div>
                <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                    {price}
                </FontBody2>
            </div>,
        ]}
    />
}

export default PlanPricingGridLine;